import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { openModal } from 'utils/modal';
import { OpsControl } from 'contexts/ops-control.context';
import { FOUND_IT, STAR_LIABLE } from 'constants/lost-or-damaged';
import { markAsFound } from 'services/ops-control';

import HubIsLiableModal from '../modals/HubIsLiableModal';
import StarIsLiableModal from '../modals/StarIsLiableModal/StarIsLiableModal';
import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as Star } from 'assets/bosta-icons/Out for Delivery.svg';
import { ReactComponent as HubIcon } from 'assets/bosta-icons/hubs.svg';

export const PendingOnFleetActions = ({ delivery, hubId }) => {
  const intl = useIntl();
  const { allHubs } = useContext(OpsControl);

  const handleHubLiableClick = () => {
    openModal(HubIsLiableModal, {
      headerTitle: intl.formatMessage({
        id: 'ops_control.lost_orders.table_actions.hub_liable'
      }),
      allHubs,
      delivery,
      modalType: FOUND_IT,
      confirmEndPoint: markAsFound
    });
  };

  const handleStarLiableClick = () => {
    openModal(StarIsLiableModal, {
      headerTitle: intl.formatMessage({
        id: 'ops_control.lost_orders.table_columns.star_liable'
      }),
      allHubs,
      hubId,
      delivery,
      modalType: STAR_LIABLE
    });
  };

  return (
    <div className="br-lost-orders__action-buttons-wrapper">
      <BRButton
        type={'basic'}
        className={'br-lost-orders__hub-liable'}
        label={intl.formatMessage({
          id: 'ops_control.lost_orders.table_actions.hub_liable'
        })}
        onClick={handleHubLiableClick}
        prefixIcon={<HubIcon />}
      />
      <BRButton
        className={'br-lost-orders__star-liable'}
        type={'basic'}
        label={intl.formatMessage({
          id: 'ops_control.lost_orders.table_columns.star_liable'
        })}
        onClick={handleStarLiableClick}
        prefixIcon={<Star />}
      />
    </div>
  );
};
